<template>
  <div class="template-detail">
    <header style="height: 56px;">
      <div class="left page-title">
        <h2>{{ projectTemplate.title }}</h2>
<!--        <h2><input-->
<!--          v-model="projectTemplate.name"-->
<!--          @click.stop="$event.target.select()"-->
<!--          placeholder="Template title"-->
<!--          type="text"-->
<!--          v-autowidth="{-->
<!--            maxWidth: '960px',-->
<!--            minWidth: '30px',-->
<!--            comfortZone: 10,-->
<!--          }"-->
<!--          v-tooltip="{ content: 'Edit', delay: 200 }"-->
<!--        /></h2>-->
        <p class="d-flex align-items-center"
           v-tooltip.bottom="{ content: projectTemplate.description, delay: { show: 700, hide: 0 } }">
          {{ projectTemplate.description }}
        </p>
      </div>

      <!--          <div class="right">-->
      <!--          <a class="button secondary-button" @click="()=> {}">Cancel</a>-->
      <!--          <a class="main-action" @click="editTemplate('details')">Save changes</a>-->
      <!--        </div>-->
      <transition name="fade">
      <div v-if="changed" class="right">
        <a class="main-action second-action" @click="setTemplate">
          Cancel changes
        </a>
        <a class="main-action" @click="save">Save Changes</a>
      </div>
      </transition>
    </header>


    <div class="main">
      <div class="left">
        <div class="panel">
          <h4 class="title">Template rules</h4>
          <p class="d-flex align-items-center">Define rules for projects that this template should apply to</p>

          <div class="rule-builder" style="overflow: auto">
<!--            <div v-for="(groupKey, iGroup) of Object.keys(projectTemplate.condition)" :key="`group-${iGroup}`" class="group">-->
<!--&lt;!&ndash;              <div class="op-selector">&ndash;&gt;-->
<!--&lt;!&ndash;                <b-form-radio-group&ndash;&gt;-->
<!--&lt;!&ndash;                  :value="groupKey"&ndash;&gt;-->
<!--&lt;!&ndash;                  :options="[Op.or, Op.and]"&ndash;&gt;-->
<!--&lt;!&ndash;                  name="condition-op-selector"&ndash;&gt;-->
<!--&lt;!&ndash;                  buttons&ndash;&gt;-->
<!--&lt;!&ndash;                  button-variant="outline-primary"&ndash;&gt;-->
<!--&lt;!&ndash;                  size="sm"&ndash;&gt;-->
<!--&lt;!&ndash;                ></b-form-radio-group>&ndash;&gt;-->
<!--&lt;!&ndash;              </div>&ndash;&gt;-->

<!--              <div class="content">-->
<!--&lt;!&ndash;                <span v-for="(condition, iCondition) of projectTemplate.condition[groupKey]">{{`${} = ${}`}}</span>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
            <TemplateBuilderGroup
              :group="projectTemplate.rules"
              :root="true"
            />
          </div>
        </div>

        <div class="panel actions">
          <h4 class="title">Project stages</h4>

          <a class="add-action-group"
          ><img src="~@/assets/icons/plus-grey.svg"
                @click="projectTemplate.actionGroups.push({title: 'New Stage', actions: []})"
          /></a>

          <div role="tablist">
            <transition-group name="list" tag="div">
              <div v-for="(group, index) of projectTemplate.actionGroups" :key="`action-group-tab-${index}`">
                <b-card no-body class="mb-1">
                  <b-card-header
                    header-tag="header"
                    class="stage-header p-1"
                    role="tab"
                    block
                    href="#"
                    v-b-toggle="`accordion-group-${index}`"
                  >
                    <i class="material-icons chevron">arrow_drop_down</i>

                    <div class="flex-header">
                      <div>
                        <input
                          class="panel-title"
                          v-model="group.title"
                          @click.stop="$event.target.select()"
                          placeholder="Stage title"
                          type="text"
                          v-autowidth="{
                              maxWidth: '960px',
                              minWidth: '30px',
                              comfortZone: 10,
                            }"
                          v-tooltip="{ content: 'Edit', delay: 200 }"
                        />
                      </div>

                    </div>
                    <a
                      class="icon-btn delete"
                      @click.stop="projectTemplate.actionGroups.splice(index, 1)"
                      v-tooltip="{ content: `Delete`, delay: 200 }"
                    ></a>
                  </b-card-header>
                  <b-collapse
                    :id="`accordion-group-${index}`"
                    :visible="!index"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <a
                        class="add-subtask"
                        @click="group.actions.push({title: 'New Task', type: 'To-do'})"
                      >
                        <div><img src="~@/assets/icons/add.svg"/>Add subtask</div>
                        <div class="icons">
                          <div class="icon attachment"/>
                        </div>
                      </a>

                      <transition-group name="list" tag="div">
                        <div
                          v-for="(action, aIndex) of group.actions"
                          :key="`action-${aIndex}`"
                          class="action"
                        >
                          <div class="action-card" @click="selectedAction = action">
                            <div class="left">

                              <div class="type-icon" :class="action.priority">
                                <div
                                  class="img"
                                  :class="
              !action || !action.type
                ? ''
                : action.type.replace(/ /g, '').toLowerCase()
            "
                                ></div>
                                <div class="flag">
                                  <svg
                                    viewBox="0 0 10 10"
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                  >
                                    <defs>
                                      <path
                                        d="M8,7.64099947 C8.41244847,7.54102233 8.9255632,7.48657365 9.61697217,7.48657365 C10.9894466,7.48657365 11.5413461,8.14229529 13.2028186,8.14229529 C14.0057244,8.14229529 14.940445,8.02844754 15.7925684,7.59218917 C16.2848957,7.34013424 16.9999945,7.49179215 16.9999945,8.06044728 C16.9999945,8.39307572 16.9999945,10.021523 16.9999945,12.9457891 C16.9999968,13.7648687 16.447006,14.4806709 15.6544634,14.6874741 C14.808023,14.9083411 13.990808,15.0121405 13.2028186,14.9988721 C11.4055843,14.9686099 10.9373777,14.3072822 9.61697217,14.2474182 C9.10528139,14.2242194 8.54831214,14.2679453 8,14.3777725 L8,16.5302897 C8,16.7897035 7.77614237,17 7.5,17 C7.22385763,17 7,16.7897035 7,16.5302897 L7,7.46971034 C7,7.21029648 7.22385763,7 7.5,7 C7.77614237,7 8,7.21029648 8,7.46971034 L8,7.64099947 Z"
                                        id="path-1"
                                      ></path>
                                    </defs>
                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                      <g transform="translate(-7.000000, -7.000000)">
                                        <mask id="mask-2" fill="white">
                                          <use xlink:href="#path-1"></use>
                                        </mask>
                                        <use
                                          fill="#979797"
                                          fill-rule="nonzero"
                                          xlink:href="#path-1"
                                        ></use>
                                      </g>
                                    </g>
                                  </svg>
                                </div>
                              </div>

                              <input
                                class="action-title"
                                v-model="action.title"
                                @click.stop="$event.target.select()"
                                placeholder="Action title"
                                type="text"
                                v-autowidth="{
                                      maxWidth: '960px',
                                      minWidth: '30px',
                                      comfortZone: 10,
                                    }"
                                v-tooltip="{ content: 'Edit', delay: 200 }"
                              />


                            </div>
                            <div class="right">
                              <a
                                class="icon-btn delete"
                                @click.stop="group.actions.splice(aIndex, 1)"
                                v-tooltip="{ content: `Delete`, delay: 200 }"
                              ></a>
                          </div>
                          </div>
                        </div>
                      </transition-group>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>

    <overflow-drop />
    <action-template-tray
      v-if="selectedAction"
      :action="selectedAction"
      @dismissed="selectedAction = null"
    />
  </div>
</template>

<script>
import {Op} from '../utils/ProjectTemplates'
import TemplateBuilderGroup from "../components/TemplateBuilderGroup";
import OverflowDrop from '../components/OverflowDrop'
import ActionTemplateTray from '../components/ActionTemplateTray'
export default {
  name: "ProjectTemplateDetails",
  components: {TemplateBuilderGroup, OverflowDrop, ActionTemplateTray},
  data: () => ({
    projectTemplate: {},
    selectedAction : null,
    changed: false,
    Op
  }),
  created() {
    this.setTemplate()
  },
  watch: {
    projectTemplate: {
      deep: true,
      handler(newVal) {
        this.changed = JSON.stringify(newVal) !== JSON.stringify(this.originalTemplate)
      }
    }
  },
  methods: {
    setTemplate() {
      this.projectTemplate = JSON.parse(JSON.stringify(this.originalTemplate))
    },
    async save() {
      await this.$store.dispatch('updateProjectTemplate', this.projectTemplate)
      this.setTemplate()
    },
    removeActionGroup(group){
      const index = this.projectTemplate.actionGroups.indexOf(group)
      this.projectTemplate.actionGroups.splice(index, 1)
    }
  },
  computed: {
    originalTemplate() {
      return this.$store.getters.projectTemplateById[this.$route.params.id]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.template-detail {

  .main {
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .panel {
      margin-top: 30px;
      padding: 25px;
      font-size: 14px;
      position: relative;

      &.actions {
        padding-bottom: 0;
      }

      .title {
        color: #26292f;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 18px;

        span {
          color: #c6d0db;
        }
      }

      .add-action-group {
        position: absolute;
        top: 22px;
        right: 25px;
        cursor: pointer;
        min-width: auto;

        &.material-select {
          top: -6px;
          right: 15px;
        }

        &.generate {
          right: 50px;
          color: #979797;
          top: 24px;

          i {
            font-size: 20px;
          }
        }
      }

      .tag {
        background: $panel-border-color;
        color: $light-text-color;
        border-radius: 3px;
        height: 25px;
        padding: 2px 14px 5px;
        display: inline-block;
        margin: 5px 0;
        width: auto;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .left {
      width: calc(100% - 364px);
    }

    .right {
      width: 334px;
    }
  }
}

.flex-title {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: nowrap;
  position: relative;

  .status {
    margin: 0 8px;
  }
}

.page-title {
  .id {
    font-size: 13px;
    color: #676a6f;
    border-radius: 4px;
    background: rgba(172, 182, 193, 0.33);
    margin-right: 10px;
    padding: 3px 8px 4px;

    span {
      color: #26292f;
    }
  }

  h2{
    input{
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      background: transparent;
      border: none;
      border-bottom: 1px solid transparent;
      outline: none;
      min-width: 0;
      max-width: calc(100% - 160px) !important;
      //height: 24px;
      margin-right: 9px;
      padding: 0 0 3px;
      font-size: inherit;
      font-weight: inherit;
      text-transform: uppercase;

      &:hover,
      &:focus,
      &:active {
        border-bottom-color: #b6bac4;
      }

      &.placeholder {
        opacity: 0.25;
      }
    }
  }
}

.info-icon {
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 17px 34px;
  background-image: url(~@/assets/icons/info_ss.svg);
  width: 17px;
  height: 17px;
  cursor: pointer;
  display: inline-block;
  position: relative;
  top: 3px;
  left: 1px;

  &:hover {
    background-position: top -17px center;
  }
}

.saving {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: nowrap;

  img {
    width: 40px;
    height: 40px;
    animation: spin 1.5s linear infinite;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    color: #565b64;
    margin: 5px 0 30px;
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.card {
  border-color: #e2e5ec !important;
  border-radius: 0px !important;
  margin-bottom: 0px !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: none !important;
  margin-left: -25px;
  margin-right: -25px;

  &:last-child,
  &:last-child .card-header.collapsed,
  &:last-child .card-body {
    border-bottom-left-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
  }
}

.card-header {
  background-color: white;
  padding: 25px 25px 18px !important;
  cursor: pointer;
  position: relative;
  border-color: #e2e5ec !important;
  border-radius: 0px !important;

  &:not(.collapsed) {
    background-color: #fbfbfc;

    .chevron {
      transform: rotate(180deg);
    }
  }

  &.collapsed {
    border-bottom-color: transparent !important;
    border-radius: 0px !important;
  }

  .chevron,
  .overflow {
    position: absolute;
    top: 21px;
    left: 33px;
    font-size: 28px;
    color: #acb6c1;
    transition: transform 0.5s;
    transform: rotate(360deg);
    user-select: none;
  }

  .overflow {
    left: auto;
    right: 25px;
    cursor: pointer;
    font-size: 18px;
  }

  h4 {
    color: #26292f;
    font-size: 16px;
    font-weight: 500;

    span {
      color: #acb6c1;
      font-weight: 400;
      font-size: 13px;

      i {
        font-size: 14px;
        position: relative;
        top: 2px;
        margin: 0 1px;
      }
    }
  }
}

.card-body {
  background-color: #fbfbfc;
  border-radius: 0px !important;
  padding: 0;

  .card-text {
    margin: 0;
  }
}

.flex-header {
  display: flex;
  flex-direction: column;
  margin-left: 60px;
  width: calc(100% - 50px);
  user-select: none;

  > div {
    display: flex;
    align-items: flex-end;
  }

  .panel-title {
    display: inline-block;
    margin-right: 9px;
    margin-bottom: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    max-width: calc(100% - 160px) !important;
    color: #26292f;
    font-size: 16px;
    font-weight: 500;
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    padding: 0;
    padding-bottom: 3px;
    height: 24px;

    &:hover,
    &:focus,
    &:active {
      border-bottom-color: #b6bac4;
    }
  }
}

.add-subtask {
  padding-left: 90px;
  height: 62px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 500;
  color: #626d79;
  cursor: pointer;
  padding-top: 3px;

  img {
    border: 1px dashed #acb6c1;
    border-radius: 20px;
    width: 30px;
    height: 30px;
    padding: 7px;
    margin-right: 12px;
    margin-top: -1px;
    opacity: 0.6;
    transition: opacity 0.3s;
  }

  .icons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 13px;
    opacity: 0;
    transition: opacity 0.3s;

    .icon {
      margin-left: 4px;
      margin-right: 12px;
      border-radius: 15px;
      border: 1px dashed #ddd;
      width: 30px;
      height: 30px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 16px 16px;
      background-image: url(~@/assets/icons/attachment.png);

      &.user {
        background-image: url(~@/assets/icons/user-grey.svg);
      }

      &.calendar {
        background-image: url(~@/assets/icons/date.svg);
      }
    }
  }

  &:hover {
    background: white;

    img {
      opacity: 1;
    }

    .icons {
      opacity: 1;
    }
  }
}

.list-move {
  transition: transform 0.5s;
}

.action {
  height: 62px;
  //cursor: pointer;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  position: relative;
  backface-visibility: hidden;

  &:hover {
    background: white;

    .checkmark {
      opacity: 1;
    }
  }

  &.current,
  &.current:hover {
    background: #e4e7ed;
  }

  .action-card {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;
    border-top: 1px solid #e2e5ec;
    margin-left: 85px;
    margin-right: 25px;
    width: calc(100% - 110px);
    height: 100%;
    transition: all 0.5s;
    cursor: pointer;

    > div {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: flex-start;
      width: 100%;

      &.right {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        justify-content: flex-end;

        .date {
          width: 44px;
          text-align: right;

          &.overdue {
            color: $red;
            text-decoration: underline;
          }

          &.attachment {
            margin: 0 10px;
            height: 18px;
            opacity: 0;

            &.visible {
              opacity: 1;
            }
          }
        }
      }

      &.left {
        flex: 1;
        max-width: calc(100% - 150px);
      }
    }

    .icon-btn {
      opacity: 0;
      transition: opacity 0.3s;
    }

    &:hover{
      .icon-btn{
        opacity: 1;
      }
    }
  }

  .type-icon {
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-right: 12px;
    position: relative;

    &.High {
      .flag {
        background: $red;
        display: flex;
      }
    }

    &.Medium {
      .flag {
        background: $orange;
        display: flex;
      }
    }

    &.Low {
      .flag {
        background: $yellow;
        display: flex;
      }
    }

    .flag {
      display: none;
      width: 18px;
      height: 18px;
      border-radius: 9px;
      background: #626d79;
      border: 1px solid white;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -6px;
      top: -6px;

      svg {
        width: 8px;
        height: 8px;

        path,
        rect,
        circle {
          fill: white;
        }
      }
    }
  }

  .action-title {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    outline: none;
    min-width: 0;
    max-width: calc(100% - 160px) !important;
    height: 24px;
    margin-right: 9px;
    padding: 0 0 3px;

    font-size: 14px;
    font-weight: 500;
    color: #26292f;

    &:hover,
    &:focus,
    &:active {
      border-bottom-color: #b6bac4;
    }

    &.placeholder {
      opacity: 0.25;
    }
  }

  .overflow {
    font-size: 18px;
    color: #acb6c1;
  }

  .attachment {
    margin: 0 0px 0 6px;
    width: 16px;
    height: 16px;
    opacity: 0;

    &.visible {
      opacity: 1;
    }
  }
}

.stage-header{
  .icon-btn {
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover{
    .icon-btn{
      opacity: 1;
    }
  }
}

.icon-btn{
  border-radius: 15px;
  width: 30px;
  height: 30px;
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: top left;

  &.delete {
    background-image: url(~@/assets/icons/trash.svg);
    background-size: 30px 30px;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
